import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import CTAPopup from '../components/CTAPopup';

const Home = () => {
  const [showCTAPopup, setShowCTAPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCTAPopup(true);
    }, 23000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <Gallery />
      <About />
      <Contact />
      <Footer />
      <CTAPopup isOpen={showCTAPopup} onClose={() => setShowCTAPopup(false)} />
    </div>
  );
};

export default Home;